import { Card, Grid, Skeleton, Stack } from '@mantine/core';
import React from 'react';

const LoaderModuleSection = () => {
  return (
    <Stack gap={24}>
      {/* Module Information Skeleton */}
      <Card withBorder>
        <Stack gap={16}>
          <Skeleton height={24} width={200} />
          <Grid>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
          </Grid>
        </Stack>
      </Card>

      {/* Job Families Skeleton */}
      <Card withBorder>
        <Stack gap={16}>
          <Skeleton height={24} width={200} />
          <Stack gap={8}>
            <Skeleton height={40} />
            <Skeleton height={30} />
            <Skeleton height={30} />
            <Skeleton height={30} />
          </Stack>
        </Stack>
      </Card>

      {/* Audit Information Skeleton */}
      <Card withBorder>
        <Stack gap={16}>
          <Skeleton height={24} width={200} />
          <Grid>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
              <Stack gap={8}>
                <Skeleton height={16} width={100} />
                <Skeleton height={20} width={150} />
              </Stack>
            </Grid.Col>
          </Grid>
        </Stack>
      </Card>
    </Stack>
  );
};

export default LoaderModuleSection;
